import { ViewModel,View, Component } from "binder"
import  { LinearChartView } from "./linearChart-view"

export class LinearChartViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new LinearChartView();
    }
    public getTypeId(): string {
        return "VM-D9240070-CE4C-4E56-9CFF-B8190DA9F101"
    }

    public set chartdata(v: linearChartData) { this._chartdata = v; } public get chartdata(): linearChartData { return this._chartdata;} private _chartdata: linearChartData;
}

export class linearChartData extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.x = [];
        this.series = [];
    }

    public set x(v: string[]) { this._x = v; } public get x(): string[] { return this._x;} private _x: string[];
    public set series(v: serie[]) { this._series = v; } public get series(): serie[] { return this._series;} private _series: serie[];
    
    
}
export class serie extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set values(v: number[]) { this._values = v; } public get values(): number[] { return this._values;} private _values: number[];
}